// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: brig/btokens.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../google/protobuf/timestamp";
import {
  TokenScope,
  tokenScopeFromJSON,
  tokenScopeToJSON,
  UserRole,
  userRoleFromJSON,
  userRoleToJSON,
} from "../models/auth";
import { Metadata } from "../models/types";
import { TokenPermission, tokenPermissionFromJSON, tokenPermissionToJSON } from "../rest/annotations";

export const protobufPackage = "brig";

/**
 * Owner informnation provides addition metadata about the token
 * being used to make a request.
 */
export interface BearerTokenOwnerInfo {
  /** The organization id which owns the token. */
  orgId: string;
  /** The organization name which owns the token. */
  orgName: string;
  /** The tenant id which owns the token. */
  tenantId: string;
  /** The tenant name which owns the token. */
  tenantName: string;
  /** The email of the token owner. */
  email: string;
  /** The role of the token owner. */
  role: UserRole;
}

/**
 * A Bearer Token is a JSON Web Token (JWT) used for authentication and authorization against
 * the Cisco Nexus Hyperfabric REST API. The JWT is a compact, URL-safe means of representing
 * a JSON object containing a set of key-value pairs as described in RFC 7159. It is passed
 * as Bearer token in the Authentication header of every HTTP API request.
 */
export interface BearerToken {
  /** The user-defined name of the bearer token. */
  name: string;
  /** The description is a user-defined field to store notes about the bearer token. */
  description: string;
  /**
   * The scope defines the level of privilege assigned to the bearer token
   * which governs the type of operations that a bearer token can perform.
   */
  scope: TokenScope;
  /**
   * The start date and time for the validity of the bearer token in
   * [RFC3339](https://datatracker.ietf.org/doc/html/rfc3339#section-5.8) format
   * (e.g. `YYYY-MM-DDTHH:MM:SSZ`).
   */
  notBefore:
    | Date
    | undefined;
  /**
   * The end date and time for the validity of the bearer token in
   * [RFC3339](https://datatracker.ietf.org/doc/html/rfc3339#section-5.8) format
   * (e.g. `YYYY-MM-DDTHH:MM:SSZ`).
   */
  notAfter:
    | Date
    | undefined;
  /**
   * The JWT token that represent the bearer token.
   * The token is only available at the bearer token creation.
   */
  token: string;
  /** The unique identifier of the bearer token. */
  tokenId: string;
  /** A map of attributes related to the lifecycle of the bearer token. */
  metadata:
    | Metadata
    | undefined;
  /** An array of one or more optional permissions which can be used to restrict what the token can do. */
  permissions: TokenPermission[];
}

/** A new bearer token definition. */
export interface NewBearerToken {
  /** The user provided name for the token. */
  name: string;
  /** A description for the token. */
  description: string;
  /** Sets the type of requests that the token can make. */
  scope: TokenScope;
  /** Sets the time at which the token can be used. */
  notBefore:
    | Date
    | undefined;
  /** Sets the time after which the token cannot be used. */
  notAfter:
    | Date
    | undefined;
  /** An array of one or more optional permissions which can be used to restrict what the token can do. */
  permissions: TokenPermission[];
}

/** Returns a list of bearer tokens. */
export interface BearerTokensResponse {
  /** A list of bearer tokens. */
  tokens: BearerToken[];
  /** Some optional owner information about the token making the request. */
  ownerInfo: BearerTokenOwnerInfo | undefined;
}

/** A request to create new bearer tokens. */
export interface CreateBearerTokenRequest {
  /** The unique name for the token. */
  name: string;
  /** A description for the token. */
  description: string;
  /** The scope of the token which sets what operations the token can perform. */
  scope: TokenScope;
  /** Time time at which a new token can be used. */
  notBefore:
    | Date
    | undefined;
  /** Time time after which the token can no longer be used. */
  notAfter:
    | Date
    | undefined;
  /** An array of one or more optional permissions which can be used to restrict what the token can do. */
  permissions: TokenPermission[];
}

/** Create a new bearer token. Currently only a single bearer token can be created at a time. */
export interface CreateBearerTokensResponse {
  /** The newly created tokens. */
  tokens: BearerToken[];
}

/** Create one or more new bearer tokens. */
export interface CreateBearerTokensRequest {
  /** The new tokens to be created. */
  tokens: NewBearerToken[];
}

/** A new onboarding device bearer token definition. */
export interface NewOnboardDeviceToken {
  /** The user provided name for the token. */
  name: string;
  /** A description for the token. */
  description: string;
}

/** Create a new onboarding device bearer token. */
export interface AddOnboardDeviceTokensRequest {
  /** The newly created tokens. */
  tokens: NewOnboardDeviceToken[];
}

/** Get a list of device onboarding tokens owned by the user. */
export interface GetOnboardDeviceTokensRequest {
}

/** Get a single bearer token. */
export interface GetBearerTokenRequest {
  /** The token id. */
  tokenId: string;
  /** Include object metadata in the response. */
  includeMetadata: boolean;
  /** Only return tokens where permissions have been set for the token. */
  restricted: boolean;
}

/** Get all bearer tokens. */
export interface GetBearerTokensRequest {
  /** Include object metadata in the response. */
  includeMetadata: boolean;
  /** Include some additional owner information about the token making the request. */
  includeOwnerInfo: boolean;
}

/** Delete a bearer token. */
export interface DeleteBearerTokenRequest {
  /** The id of the token to delete. */
  tokenId: string;
}

/**
 * A request to create a new restricted token. A restricted token is a bearer token
 * that is scoped to a specific permission. This is the infrastructure for features
 * like multisite invitations, user registration, etc.
 */
export interface CreateRestrictedTokenRequest {
  /** The name of the restricted token. */
  name: string;
  /** A description for the restricted token. */
  description: string;
  /** The start date and time for the validity of the token. */
  notBefore:
    | Date
    | undefined;
  /** The end date and time for the validity of the token. */
  notAfter:
    | Date
    | undefined;
  /** The permissions to restrict the token to. */
  permissions: TokenPermission[];
}

function createBaseBearerTokenOwnerInfo(): BearerTokenOwnerInfo {
  return { orgId: "", orgName: "", tenantId: "", tenantName: "", email: "", role: 0 };
}

export const BearerTokenOwnerInfo: MessageFns<BearerTokenOwnerInfo> = {
  encode(message: BearerTokenOwnerInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.orgName !== "") {
      writer.uint32(18).string(message.orgName);
    }
    if (message.tenantId !== "") {
      writer.uint32(26).string(message.tenantId);
    }
    if (message.tenantName !== "") {
      writer.uint32(34).string(message.tenantName);
    }
    if (message.email !== "") {
      writer.uint32(42).string(message.email);
    }
    if (message.role !== 0) {
      writer.uint32(48).int32(message.role);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BearerTokenOwnerInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBearerTokenOwnerInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tenantId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tenantName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.role = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BearerTokenOwnerInfo {
    return {
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      orgName: isSet(object.orgName) ? globalThis.String(object.orgName) : "",
      tenantId: isSet(object.tenantId) ? globalThis.String(object.tenantId) : "",
      tenantName: isSet(object.tenantName) ? globalThis.String(object.tenantName) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      role: isSet(object.role) ? userRoleFromJSON(object.role) : 0,
    };
  },

  toJSON(message: BearerTokenOwnerInfo): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.orgName !== "") {
      obj.orgName = message.orgName;
    }
    if (message.tenantId !== "") {
      obj.tenantId = message.tenantId;
    }
    if (message.tenantName !== "") {
      obj.tenantName = message.tenantName;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.role !== 0) {
      obj.role = userRoleToJSON(message.role);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BearerTokenOwnerInfo>, I>>(base?: I): BearerTokenOwnerInfo {
    return BearerTokenOwnerInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BearerTokenOwnerInfo>, I>>(object: I): BearerTokenOwnerInfo {
    const message = createBaseBearerTokenOwnerInfo();
    message.orgId = object.orgId ?? "";
    message.orgName = object.orgName ?? "";
    message.tenantId = object.tenantId ?? "";
    message.tenantName = object.tenantName ?? "";
    message.email = object.email ?? "";
    message.role = object.role ?? 0;
    return message;
  },
};

function createBaseBearerToken(): BearerToken {
  return {
    name: "",
    description: "",
    scope: 0,
    notBefore: undefined,
    notAfter: undefined,
    token: "",
    tokenId: "",
    metadata: undefined,
    permissions: [],
  };
}

export const BearerToken: MessageFns<BearerToken> = {
  encode(message: BearerToken, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    if (message.scope !== 0) {
      writer.uint32(24).int32(message.scope);
    }
    if (message.notBefore !== undefined) {
      Timestamp.encode(toTimestamp(message.notBefore), writer.uint32(34).fork()).join();
    }
    if (message.notAfter !== undefined) {
      Timestamp.encode(toTimestamp(message.notAfter), writer.uint32(42).fork()).join();
    }
    if (message.token !== "") {
      writer.uint32(50).string(message.token);
    }
    if (message.tokenId !== "") {
      writer.uint32(58).string(message.tokenId);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(66).fork()).join();
    }
    writer.uint32(74).fork();
    for (const v of message.permissions) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BearerToken {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBearerToken();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.scope = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.notBefore = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.notAfter = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.token = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.tokenId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag === 72) {
            message.permissions.push(reader.int32() as any);

            continue;
          }

          if (tag === 74) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.permissions.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BearerToken {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      scope: isSet(object.scope) ? tokenScopeFromJSON(object.scope) : 0,
      notBefore: isSet(object.notBefore) ? fromJsonTimestamp(object.notBefore) : undefined,
      notAfter: isSet(object.notAfter) ? fromJsonTimestamp(object.notAfter) : undefined,
      token: isSet(object.token) ? globalThis.String(object.token) : "",
      tokenId: isSet(object.tokenId) ? globalThis.String(object.tokenId) : "",
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      permissions: globalThis.Array.isArray(object?.permissions)
        ? object.permissions.map((e: any) => tokenPermissionFromJSON(e))
        : [],
    };
  },

  toJSON(message: BearerToken): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.scope !== 0) {
      obj.scope = tokenScopeToJSON(message.scope);
    }
    if (message.notBefore !== undefined) {
      obj.notBefore = message.notBefore.toISOString();
    }
    if (message.notAfter !== undefined) {
      obj.notAfter = message.notAfter.toISOString();
    }
    if (message.token !== "") {
      obj.token = message.token;
    }
    if (message.tokenId !== "") {
      obj.tokenId = message.tokenId;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.permissions?.length) {
      obj.permissions = message.permissions.map((e) => tokenPermissionToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BearerToken>, I>>(base?: I): BearerToken {
    return BearerToken.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BearerToken>, I>>(object: I): BearerToken {
    const message = createBaseBearerToken();
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.scope = object.scope ?? 0;
    message.notBefore = object.notBefore ?? undefined;
    message.notAfter = object.notAfter ?? undefined;
    message.token = object.token ?? "";
    message.tokenId = object.tokenId ?? "";
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.permissions = object.permissions?.map((e) => e) || [];
    return message;
  },
};

function createBaseNewBearerToken(): NewBearerToken {
  return { name: "", description: "", scope: 0, notBefore: undefined, notAfter: undefined, permissions: [] };
}

export const NewBearerToken: MessageFns<NewBearerToken> = {
  encode(message: NewBearerToken, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    if (message.scope !== 0) {
      writer.uint32(24).int32(message.scope);
    }
    if (message.notBefore !== undefined) {
      Timestamp.encode(toTimestamp(message.notBefore), writer.uint32(34).fork()).join();
    }
    if (message.notAfter !== undefined) {
      Timestamp.encode(toTimestamp(message.notAfter), writer.uint32(42).fork()).join();
    }
    writer.uint32(50).fork();
    for (const v of message.permissions) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NewBearerToken {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNewBearerToken();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.scope = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.notBefore = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.notAfter = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag === 48) {
            message.permissions.push(reader.int32() as any);

            continue;
          }

          if (tag === 50) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.permissions.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NewBearerToken {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      scope: isSet(object.scope) ? tokenScopeFromJSON(object.scope) : 0,
      notBefore: isSet(object.notBefore) ? fromJsonTimestamp(object.notBefore) : undefined,
      notAfter: isSet(object.notAfter) ? fromJsonTimestamp(object.notAfter) : undefined,
      permissions: globalThis.Array.isArray(object?.permissions)
        ? object.permissions.map((e: any) => tokenPermissionFromJSON(e))
        : [],
    };
  },

  toJSON(message: NewBearerToken): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.scope !== 0) {
      obj.scope = tokenScopeToJSON(message.scope);
    }
    if (message.notBefore !== undefined) {
      obj.notBefore = message.notBefore.toISOString();
    }
    if (message.notAfter !== undefined) {
      obj.notAfter = message.notAfter.toISOString();
    }
    if (message.permissions?.length) {
      obj.permissions = message.permissions.map((e) => tokenPermissionToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NewBearerToken>, I>>(base?: I): NewBearerToken {
    return NewBearerToken.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NewBearerToken>, I>>(object: I): NewBearerToken {
    const message = createBaseNewBearerToken();
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.scope = object.scope ?? 0;
    message.notBefore = object.notBefore ?? undefined;
    message.notAfter = object.notAfter ?? undefined;
    message.permissions = object.permissions?.map((e) => e) || [];
    return message;
  },
};

function createBaseBearerTokensResponse(): BearerTokensResponse {
  return { tokens: [], ownerInfo: undefined };
}

export const BearerTokensResponse: MessageFns<BearerTokensResponse> = {
  encode(message: BearerTokensResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tokens) {
      BearerToken.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.ownerInfo !== undefined) {
      BearerTokenOwnerInfo.encode(message.ownerInfo, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BearerTokensResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBearerTokensResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tokens.push(BearerToken.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.ownerInfo = BearerTokenOwnerInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BearerTokensResponse {
    return {
      tokens: globalThis.Array.isArray(object?.tokens) ? object.tokens.map((e: any) => BearerToken.fromJSON(e)) : [],
      ownerInfo: isSet(object.ownerInfo) ? BearerTokenOwnerInfo.fromJSON(object.ownerInfo) : undefined,
    };
  },

  toJSON(message: BearerTokensResponse): unknown {
    const obj: any = {};
    if (message.tokens?.length) {
      obj.tokens = message.tokens.map((e) => BearerToken.toJSON(e));
    }
    if (message.ownerInfo !== undefined) {
      obj.ownerInfo = BearerTokenOwnerInfo.toJSON(message.ownerInfo);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BearerTokensResponse>, I>>(base?: I): BearerTokensResponse {
    return BearerTokensResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BearerTokensResponse>, I>>(object: I): BearerTokensResponse {
    const message = createBaseBearerTokensResponse();
    message.tokens = object.tokens?.map((e) => BearerToken.fromPartial(e)) || [];
    message.ownerInfo = (object.ownerInfo !== undefined && object.ownerInfo !== null)
      ? BearerTokenOwnerInfo.fromPartial(object.ownerInfo)
      : undefined;
    return message;
  },
};

function createBaseCreateBearerTokenRequest(): CreateBearerTokenRequest {
  return { name: "", description: "", scope: 0, notBefore: undefined, notAfter: undefined, permissions: [] };
}

export const CreateBearerTokenRequest: MessageFns<CreateBearerTokenRequest> = {
  encode(message: CreateBearerTokenRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    if (message.scope !== 0) {
      writer.uint32(24).int32(message.scope);
    }
    if (message.notBefore !== undefined) {
      Timestamp.encode(toTimestamp(message.notBefore), writer.uint32(34).fork()).join();
    }
    if (message.notAfter !== undefined) {
      Timestamp.encode(toTimestamp(message.notAfter), writer.uint32(42).fork()).join();
    }
    writer.uint32(50).fork();
    for (const v of message.permissions) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateBearerTokenRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateBearerTokenRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.scope = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.notBefore = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.notAfter = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag === 48) {
            message.permissions.push(reader.int32() as any);

            continue;
          }

          if (tag === 50) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.permissions.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateBearerTokenRequest {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      scope: isSet(object.scope) ? tokenScopeFromJSON(object.scope) : 0,
      notBefore: isSet(object.notBefore) ? fromJsonTimestamp(object.notBefore) : undefined,
      notAfter: isSet(object.notAfter) ? fromJsonTimestamp(object.notAfter) : undefined,
      permissions: globalThis.Array.isArray(object?.permissions)
        ? object.permissions.map((e: any) => tokenPermissionFromJSON(e))
        : [],
    };
  },

  toJSON(message: CreateBearerTokenRequest): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.scope !== 0) {
      obj.scope = tokenScopeToJSON(message.scope);
    }
    if (message.notBefore !== undefined) {
      obj.notBefore = message.notBefore.toISOString();
    }
    if (message.notAfter !== undefined) {
      obj.notAfter = message.notAfter.toISOString();
    }
    if (message.permissions?.length) {
      obj.permissions = message.permissions.map((e) => tokenPermissionToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateBearerTokenRequest>, I>>(base?: I): CreateBearerTokenRequest {
    return CreateBearerTokenRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateBearerTokenRequest>, I>>(object: I): CreateBearerTokenRequest {
    const message = createBaseCreateBearerTokenRequest();
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.scope = object.scope ?? 0;
    message.notBefore = object.notBefore ?? undefined;
    message.notAfter = object.notAfter ?? undefined;
    message.permissions = object.permissions?.map((e) => e) || [];
    return message;
  },
};

function createBaseCreateBearerTokensResponse(): CreateBearerTokensResponse {
  return { tokens: [] };
}

export const CreateBearerTokensResponse: MessageFns<CreateBearerTokensResponse> = {
  encode(message: CreateBearerTokensResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tokens) {
      BearerToken.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateBearerTokensResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateBearerTokensResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tokens.push(BearerToken.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateBearerTokensResponse {
    return {
      tokens: globalThis.Array.isArray(object?.tokens) ? object.tokens.map((e: any) => BearerToken.fromJSON(e)) : [],
    };
  },

  toJSON(message: CreateBearerTokensResponse): unknown {
    const obj: any = {};
    if (message.tokens?.length) {
      obj.tokens = message.tokens.map((e) => BearerToken.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateBearerTokensResponse>, I>>(base?: I): CreateBearerTokensResponse {
    return CreateBearerTokensResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateBearerTokensResponse>, I>>(object: I): CreateBearerTokensResponse {
    const message = createBaseCreateBearerTokensResponse();
    message.tokens = object.tokens?.map((e) => BearerToken.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateBearerTokensRequest(): CreateBearerTokensRequest {
  return { tokens: [] };
}

export const CreateBearerTokensRequest: MessageFns<CreateBearerTokensRequest> = {
  encode(message: CreateBearerTokensRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tokens) {
      NewBearerToken.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateBearerTokensRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateBearerTokensRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tokens.push(NewBearerToken.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateBearerTokensRequest {
    return {
      tokens: globalThis.Array.isArray(object?.tokens) ? object.tokens.map((e: any) => NewBearerToken.fromJSON(e)) : [],
    };
  },

  toJSON(message: CreateBearerTokensRequest): unknown {
    const obj: any = {};
    if (message.tokens?.length) {
      obj.tokens = message.tokens.map((e) => NewBearerToken.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateBearerTokensRequest>, I>>(base?: I): CreateBearerTokensRequest {
    return CreateBearerTokensRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateBearerTokensRequest>, I>>(object: I): CreateBearerTokensRequest {
    const message = createBaseCreateBearerTokensRequest();
    message.tokens = object.tokens?.map((e) => NewBearerToken.fromPartial(e)) || [];
    return message;
  },
};

function createBaseNewOnboardDeviceToken(): NewOnboardDeviceToken {
  return { name: "", description: "" };
}

export const NewOnboardDeviceToken: MessageFns<NewOnboardDeviceToken> = {
  encode(message: NewOnboardDeviceToken, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NewOnboardDeviceToken {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNewOnboardDeviceToken();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NewOnboardDeviceToken {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
    };
  },

  toJSON(message: NewOnboardDeviceToken): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NewOnboardDeviceToken>, I>>(base?: I): NewOnboardDeviceToken {
    return NewOnboardDeviceToken.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NewOnboardDeviceToken>, I>>(object: I): NewOnboardDeviceToken {
    const message = createBaseNewOnboardDeviceToken();
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseAddOnboardDeviceTokensRequest(): AddOnboardDeviceTokensRequest {
  return { tokens: [] };
}

export const AddOnboardDeviceTokensRequest: MessageFns<AddOnboardDeviceTokensRequest> = {
  encode(message: AddOnboardDeviceTokensRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tokens) {
      NewOnboardDeviceToken.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddOnboardDeviceTokensRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddOnboardDeviceTokensRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tokens.push(NewOnboardDeviceToken.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddOnboardDeviceTokensRequest {
    return {
      tokens: globalThis.Array.isArray(object?.tokens)
        ? object.tokens.map((e: any) => NewOnboardDeviceToken.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AddOnboardDeviceTokensRequest): unknown {
    const obj: any = {};
    if (message.tokens?.length) {
      obj.tokens = message.tokens.map((e) => NewOnboardDeviceToken.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddOnboardDeviceTokensRequest>, I>>(base?: I): AddOnboardDeviceTokensRequest {
    return AddOnboardDeviceTokensRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddOnboardDeviceTokensRequest>, I>>(
    object: I,
  ): AddOnboardDeviceTokensRequest {
    const message = createBaseAddOnboardDeviceTokensRequest();
    message.tokens = object.tokens?.map((e) => NewOnboardDeviceToken.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetOnboardDeviceTokensRequest(): GetOnboardDeviceTokensRequest {
  return {};
}

export const GetOnboardDeviceTokensRequest: MessageFns<GetOnboardDeviceTokensRequest> = {
  encode(_: GetOnboardDeviceTokensRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOnboardDeviceTokensRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOnboardDeviceTokensRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetOnboardDeviceTokensRequest {
    return {};
  },

  toJSON(_: GetOnboardDeviceTokensRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOnboardDeviceTokensRequest>, I>>(base?: I): GetOnboardDeviceTokensRequest {
    return GetOnboardDeviceTokensRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOnboardDeviceTokensRequest>, I>>(_: I): GetOnboardDeviceTokensRequest {
    const message = createBaseGetOnboardDeviceTokensRequest();
    return message;
  },
};

function createBaseGetBearerTokenRequest(): GetBearerTokenRequest {
  return { tokenId: "", includeMetadata: false, restricted: false };
}

export const GetBearerTokenRequest: MessageFns<GetBearerTokenRequest> = {
  encode(message: GetBearerTokenRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tokenId !== "") {
      writer.uint32(10).string(message.tokenId);
    }
    if (message.includeMetadata !== false) {
      writer.uint32(16).bool(message.includeMetadata);
    }
    if (message.restricted !== false) {
      writer.uint32(24).bool(message.restricted);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBearerTokenRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBearerTokenRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tokenId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.restricted = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBearerTokenRequest {
    return {
      tokenId: isSet(object.tokenId) ? globalThis.String(object.tokenId) : "",
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
      restricted: isSet(object.restricted) ? globalThis.Boolean(object.restricted) : false,
    };
  },

  toJSON(message: GetBearerTokenRequest): unknown {
    const obj: any = {};
    if (message.tokenId !== "") {
      obj.tokenId = message.tokenId;
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    if (message.restricted !== false) {
      obj.restricted = message.restricted;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBearerTokenRequest>, I>>(base?: I): GetBearerTokenRequest {
    return GetBearerTokenRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBearerTokenRequest>, I>>(object: I): GetBearerTokenRequest {
    const message = createBaseGetBearerTokenRequest();
    message.tokenId = object.tokenId ?? "";
    message.includeMetadata = object.includeMetadata ?? false;
    message.restricted = object.restricted ?? false;
    return message;
  },
};

function createBaseGetBearerTokensRequest(): GetBearerTokensRequest {
  return { includeMetadata: false, includeOwnerInfo: false };
}

export const GetBearerTokensRequest: MessageFns<GetBearerTokensRequest> = {
  encode(message: GetBearerTokensRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.includeMetadata !== false) {
      writer.uint32(8).bool(message.includeMetadata);
    }
    if (message.includeOwnerInfo !== false) {
      writer.uint32(16).bool(message.includeOwnerInfo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBearerTokensRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBearerTokensRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.includeOwnerInfo = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBearerTokensRequest {
    return {
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
      includeOwnerInfo: isSet(object.includeOwnerInfo) ? globalThis.Boolean(object.includeOwnerInfo) : false,
    };
  },

  toJSON(message: GetBearerTokensRequest): unknown {
    const obj: any = {};
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    if (message.includeOwnerInfo !== false) {
      obj.includeOwnerInfo = message.includeOwnerInfo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBearerTokensRequest>, I>>(base?: I): GetBearerTokensRequest {
    return GetBearerTokensRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBearerTokensRequest>, I>>(object: I): GetBearerTokensRequest {
    const message = createBaseGetBearerTokensRequest();
    message.includeMetadata = object.includeMetadata ?? false;
    message.includeOwnerInfo = object.includeOwnerInfo ?? false;
    return message;
  },
};

function createBaseDeleteBearerTokenRequest(): DeleteBearerTokenRequest {
  return { tokenId: "" };
}

export const DeleteBearerTokenRequest: MessageFns<DeleteBearerTokenRequest> = {
  encode(message: DeleteBearerTokenRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tokenId !== "") {
      writer.uint32(10).string(message.tokenId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteBearerTokenRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteBearerTokenRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tokenId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteBearerTokenRequest {
    return { tokenId: isSet(object.tokenId) ? globalThis.String(object.tokenId) : "" };
  },

  toJSON(message: DeleteBearerTokenRequest): unknown {
    const obj: any = {};
    if (message.tokenId !== "") {
      obj.tokenId = message.tokenId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteBearerTokenRequest>, I>>(base?: I): DeleteBearerTokenRequest {
    return DeleteBearerTokenRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteBearerTokenRequest>, I>>(object: I): DeleteBearerTokenRequest {
    const message = createBaseDeleteBearerTokenRequest();
    message.tokenId = object.tokenId ?? "";
    return message;
  },
};

function createBaseCreateRestrictedTokenRequest(): CreateRestrictedTokenRequest {
  return { name: "", description: "", notBefore: undefined, notAfter: undefined, permissions: [] };
}

export const CreateRestrictedTokenRequest: MessageFns<CreateRestrictedTokenRequest> = {
  encode(message: CreateRestrictedTokenRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    if (message.notBefore !== undefined) {
      Timestamp.encode(toTimestamp(message.notBefore), writer.uint32(26).fork()).join();
    }
    if (message.notAfter !== undefined) {
      Timestamp.encode(toTimestamp(message.notAfter), writer.uint32(34).fork()).join();
    }
    writer.uint32(42).fork();
    for (const v of message.permissions) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateRestrictedTokenRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateRestrictedTokenRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.notBefore = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.notAfter = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag === 40) {
            message.permissions.push(reader.int32() as any);

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.permissions.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateRestrictedTokenRequest {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      notBefore: isSet(object.notBefore) ? fromJsonTimestamp(object.notBefore) : undefined,
      notAfter: isSet(object.notAfter) ? fromJsonTimestamp(object.notAfter) : undefined,
      permissions: globalThis.Array.isArray(object?.permissions)
        ? object.permissions.map((e: any) => tokenPermissionFromJSON(e))
        : [],
    };
  },

  toJSON(message: CreateRestrictedTokenRequest): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.notBefore !== undefined) {
      obj.notBefore = message.notBefore.toISOString();
    }
    if (message.notAfter !== undefined) {
      obj.notAfter = message.notAfter.toISOString();
    }
    if (message.permissions?.length) {
      obj.permissions = message.permissions.map((e) => tokenPermissionToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateRestrictedTokenRequest>, I>>(base?: I): CreateRestrictedTokenRequest {
    return CreateRestrictedTokenRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateRestrictedTokenRequest>, I>>(object: I): CreateRestrictedTokenRequest {
    const message = createBaseCreateRestrictedTokenRequest();
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.notBefore = object.notBefore ?? undefined;
    message.notAfter = object.notAfter ?? undefined;
    message.permissions = object.permissions?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000).toString();
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
